import {styled} from "@mui/material";

export const HomeContainer = styled('div')`
  background: rgb(242, 242, 242);
  display: flex;
`